import { useMemo } from 'react';

function getLevelCss(level = '1') {
    switch (level) {
        case '2':
            return 'text-3xl lg:text-5xl xl:text-6xl';
        case '3':
            return 'text-2xl lg:text-3xl xl:text-5xl';
        case '4':
            return 'text-xl lg:text-4xl';
        case '5':
            return 'text-lg lg:text-3xl';
        case '6':
            return 'text-base lg:text-2xl';
        default:
            return 'text-4xl lg:text-6xl xl:text-7xl';
    }
}
const useHeadingStyles = (level) => {
    const styles = useMemo(() => {
        return [getLevelCss(level)].join(' ');
    }, [level]);
    return styles;
};

export { useHeadingStyles };
//# sourceMappingURL=useHeadingStyles.js.map
